export default "__VITE_ASSET__Ds66Ti43__"